import { css } from 'lit';

export const relatedEntitiesSectionStyles = css`
  .related-entities-section {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: baseline;
    margin-top: -1px;
    border-top: 1px solid var(--borderColor);
    padding: 12px 0 12px 32px;
    background-position: -2px 7px;
    background-repeat: no-repeat;
    background-size: 30px;
    line-height: 140%;
  }
  .collection-section {
    background-image: url(/images/collections-color.svg);
  }
  .risk-assessment-section {
    background-image: url(/images/risk-assessments-color.svg);
  }
  .related-entities-section a {
    margin: -6px 0;
    padding: 6px 4px;
    color: var(--linkColorGray);
    text-decoration: none;
  }
  @media (hover: hover) {
    .related-entities-section a:hover {
      color: var(--themeColor);
    }
  }
  .related-entities-section d-action:last-child {
    margin: -6px -8px -6px 0;
  }
`;
